import { GridPagingController } from './GridPagingController';

export class GridPagingDirective implements angular.IDirective {
    public bindToController: boolean = true;
    public controller = GridPagingController;
    public controllerAs: string = GridPagingController.$controllerAs;

    public scope: any = {
        displayNumPages: '=?gvDisplayNumPages',
        displayPageSize: '=?gvDisplayPageSize',
        limit: '=gvLimit',
        onPaginate: '=?gvOnPaginate',
        page: '=gvPage',
        pageSelect: '=?gvPageSelect',
        pagingOptions: '=?gvPagingOptions',
        total: '@gvTotal'
    };

    public template: string = require('!!html-loader!./PagingView.html');

    public compile(tElement: angular.IAugmentedJQuery) {
        tElement.addClass('gv-table-pagination');
    }

    public static Factory() {
        let directive = () => {
            return new GridPagingDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
